export default function(value) {
    /**
     * Formats full name in Initials
     * Example: Ross Alex  => RA
     * @param {String} value
     * @return {String}
     */
    if (!value) {
        return '';
    }

    // Remove spaces and split string to array
    let text = value
        .trim()
        .replace(/\s\s+/g, ' ')
        .split(' ');

    if (text.length >= 2) {
        return `${text[0].charAt(0).toUpperCase()}${text[1]
            .charAt(0)
            .toUpperCase()}`;
    }
    return text[0].charAt(0).toUpperCase();
}
